import type { Store } from '@jane/shared/types';

/** Kiosk accepts orders if they are open at any point during the day */
export const isAcceptingOrders = (store: Store) => {
  const today = new Date().getDay();
  const scheduleToday = store.working_hours && store.working_hours[today];

  const startTime = scheduleToday?.period.from;
  const endTime = scheduleToday?.period.to;

  if (startTime && endTime) {
    return true;
  }

  return false;
};

export const nextAvailableSchedule = (store: Store) => {
  const today = new Date().getDay();
  let nextDay = today + 1;

  while (nextDay !== today) {
    if (nextDay === 7) {
      nextDay = 0;
    }

    const nextSchedule = store.working_hours && store.working_hours[nextDay];

    const startTime = nextSchedule?.period.from;
    const endTime = nextSchedule?.period.to;

    if (startTime && endTime) {
      return nextSchedule;
    } else {
      nextDay++;
    }
  }

  const scheduleToday = store.working_hours && store.working_hours[today];

  const startTime = scheduleToday?.period.from;
  const endTime = scheduleToday?.period.to;

  if (startTime && endTime) {
    return scheduleToday;
  }

  return null;
};
